export interface PsaConfigurator {
  tab_id: string;
  tab_name: string;
  actions: Actions[];
}

export enum Actions {
  DETAIL = 'DETAIL',
  CENTER_MAP = 'CENTER_MAP',
  EVIDENCE = 'EVIDENCE',
  DOWNLOAD_MATRICE_RISCHIO = 'MATRICE_RISCHIO',
  ASSOCIATED_ACTIONS = 'ASSOCIATED_ACTIONS',
  ASSOCIATED_ELEMENTS = 'ASSOCIATED_ELEMENTS',
  MODIFY = 'MODIFY',
  DELETE = 'DELETE',
  CHECK_LIST = 'CHECK_LIST'
}

export interface Entity {
  id: string;
  deleted: number;
  geom: {
    crs: {
      type: string;
      properties: {
        name: string;
      };
    };
    type: string;
    coordinates?: number[]; // Se servono le coordinate, puoi aggiungere questo attributo
  };
  nodoA_id: string | null;
  nodoB_id: string | null;
  rete_idrica_ids: string[];
  search_term: string;
  stato: string;
  tipologia: string;
  type: string;
  urn: string;
  // per supporto a sviluppo web
  selected?: boolean;
}

export interface ReteIdrica {
  id: string;
  attr1: string;
  attr2: string;
  attr3: string;
  attr4: string;
  import_id: string;
  deleted: number;
}

export interface Nodo {
  id: string;
  id_rete_idrica: string;
  tipo: string;
  tipologia: string;
  stato: string;
  posizione: any;
  matrice_rischio: string;
}

export interface Interconnessione {
  id: string;
  id_rete_idrica: string;
  nodoA_id: string;
  nodoB_id: string;
  tipologia: string;
  tipo: string;
  percorso: any;
}

export interface EventoRischio {
  id: string;
  nome: string;
  descrizione: string;
  tipologia: string;
  probabilita: number;
  lavorato: boolean;
}

export interface RelEntityEventoRischio {
  id: string;
  entity_type: string; // 'nodo' | 'interconnessione'
  entity_id: string;
  evento_rischio_id: string;
  probabilita: number;
  lavorato: boolean;
}

export interface RelEventoRischioAzioneMitigatrice {
  id: string;
  evento_rischio_id: string;
  azione_mitigatrice_id: string;
}

export interface AzioneMitigatrice {
  id: string;
  azione_mitigatrice_id: string;
  nome: string;
  descrizione: string;
  riduzione_rischio: number;
  stato: string;
}

export interface RelEntityEventoRischioAzioneMitigatrice {
  id: string;
  rel_entity_evento_rischio_id: string;
  azione_mitigatrice_id: string;
  stato: number;
  riduzione_rischio: number;
}

export interface MatriceRischio {
  id: string;
  entity_type: string; // 'nodo' | 'interconnessione'
  entity_id: string;
  probabilita_rischio_complessivo: number;
  valore_azioni_mitigatrici: number;
}

export interface Checklist {
  id: number;
  type: string;
  group: string;
  section: string;
  entity_type: string;
  field_name: string;
  field_type: string;
  field_options: string;
  description_title: string;
  description_required: boolean;
}

export interface RelEntityChecklist {
  id: number;
  entity_id: string;
  checklist_id: number;
  field_value: string;
  description_value: string;
  note: string;
  user_id: string;
  created_at: Date;
}
